import { Box, Typography } from '@mui/material';
import TableImage from 'assets/TableImage.webp';
import { allowedFilesMap } from './DataSetForm';

export default function TableDescription() {
  return (
    <Box>
      <Typography variant='h6'>"Table" Chunking Method Description</Typography>
      <Typography marginTop={1}>{allowedFilesMap._table.join(', ')} format files are supported.</Typography>
      <Typography>Here're some tips:</Typography>
      <ul>
        <li>For csv or txt file, the delimiter between columns is TAB.</li>
        <li>The first line must be column headers.</li>
        <li>
          Column headers must be meaningful terms in order to make our LLM understanding. It's good to enumerate some
          synonyms using slash '/' to separate, and even better to enumerate values using brackets like
          'gender/sex(male, female)'.
        </li>
        <li>Every row in table will be treated as a chunk.</li>
      </ul>

      <Typography fontWeight='500' marginTop={3}>
        "Table" Examples
      </Typography>
      <Typography marginBottom={3}>The following screenshots are presented to facilitate understanding.</Typography>
      <img src={TableImage} alt='GeneralStep1' />
    </Box>
  );
}
